module.exports = __webpack_public_path__ + "resources/img/bg_cover_intro_m.c650045e31c61736ee5aa385a66583c9.png";